import React from "react";
import ResetPassword from "../Components/user/ResetPassword";

const ResetPassPage = () => {
  return (
    <div>
      <ResetPassword />
    </div>
  );
};

export default ResetPassPage;
